const wowApp = require('angular').module('wowApp.common');

wowApp.component('wowCopyright', require('./copyright.component').copyrightControllerComponentDefinition);



// WEBPACK FOOTER //
// ./src/common/copyright/index.js